/**
 * The tabs of Training and of Diet. A route's address is checked in the part of it that loads with
 * every page, so this stays away from the page's own code.
 */
export const HUB_TABS = ["today", "plans", "recovery", "history", "progress", "packs", "notes"] as const;
export type HubTab = (typeof HUB_TABS)[number];

export const DIET_TABS = ["today", "plans"] as const;
export type DietTab = (typeof DIET_TABS)[number];
